export function Hyphenated(text) {
  return text?.toLowerCase()?.replace(/ /g, "-");
}
